import type { ReactNode } from "react";
import { BannerHeader } from "./banner-header";

interface CollapsibleBannerProps {
  title: string;
  icon?: ReactNode;
  expanded: boolean;
  onToggle: () => void;
  onDismiss?: () => void;
  children?: ReactNode;
}

export function CollapsibleBanner({
  title,
  icon,
  expanded,
  onToggle,
  onDismiss,
  children,
}: CollapsibleBannerProps) {
  return (
    <div className="rounded-t-2xl border-x border-t border-surfaces-z4 bg-surfaces-z3 px-4 pb-4 pt-4">
      <BannerHeader
        title={title}
        icon={icon}
        expanded={expanded}
        onToggle={onToggle}
        onDismiss={onDismiss}
      />
      {expanded ? <div className="mt-1">{children}</div> : null}
    </div>
  );
}
